<template>
  <div
    class="svg-container"
    ref="container"
    @mouseover="drawLineStart"
    @mouseout="drawLineEnd"
  >
    <!-- 边框路径 -->
    <svg :height="height" :width="width" class="svg-border">
      <defs>
        <linearGradient id="linear" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#41D5A0" />
          <stop offset="100%" stop-color="#E3DC05" />
        </linearGradient>
      </defs>
      <polygon
        ref="polygon"
        :points="points"
        :fill="bgColor"
        stroke="#41D49F"
        stroke-width="1"
      />
    </svg>
    <svg :height="height" :width="width" class="svg-border" style="z-index: 4">
      <defs>
        <linearGradient id="linear2" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#02FFA3" />
          <stop offset="100%" stop-color="#00F6FF" />
        </linearGradient>
      </defs>
      <polygon
        ref="polygonDraw"
        :points="points"
        fill="none"
        stroke="url(#linear2)"
        stroke-width="1"
      />
    </svg>
    <!-- 右上角 -->
    <svg :height="height" :width="width" class="svg-border-top">
      <polyline
        :points="pointsTop"
        fill="none"
        stroke="#EEEA0E"
        stroke-width="1"
      />
    </svg>
    <!-- 右下角 -->
    <svg :height="height" :width="width" class="svg-border-bottom">
      <polyline
        :points="pointsBottom"
        fill="none"
        stroke="#EEEA0E"
        stroke-width="1"
      />
    </svg>
    <!-- 线段 -->
    <div
      class="line-move"
      :ref="'line-move-first-' + (index + 1)"
      v-for="(item, index) in 10"
      :key="index"
      :class="{ green: index < 5 }"
    ></div>
    <!-- 边框杂色1 -->
    <div v-if="isMottledShow">
      <div class="mottled first"></div>
      <div class="mottled second"></div>
      <div class="mottled third"></div>
      <div class="mottled fourth"></div>
      <div class="mottled fifth"></div>
      <div class="mottled sixth"></div>
    </div>
    <!-- 内容容器 -->
    <div class="svg-content-container">
      <!-- 标题 -->
      <div class="svg-title">
        <div>
          {{ title }}
          <img
            class="img_a1"
            src="../../assets/common/title-arrow.png"
            alt=""
          />
          <img
            v-if="addShow"
            @click="handleAdd"
            class="img_a2"
            src="../../assets/common/tianjia.png"
            alt=""
          />
        </div>
        <div>
          <slot name="icon"></slot>
        </div>
      </div>
      <!-- 标题下边框 -->
      <div class="svg-title-border">
        <img src="../../assets/common/title-line.png" alt="" />
      </div>
      <div class="svg-content-center"><slot></slot></div>
    </div>
    <!-- 扇形 -->
    <div class="mask"></div>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default() {
          return '标题'
        },
      },
      bgColor: {
        type: String,
        default() {
          return '#191f21'
        },
      },
      addShow: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        height: 0,
        width: 0,
        points: '',
        pointsTop: '',
        pointsBottom: '',
        drawLineAn: null,
        drawDirection: 1,
        isMottledShow: true,
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.init()
      })
      window.onresize = () => {
        this.$nextTick(() => {
          this.init()
        })
      }
    },
    beforeDestroy() {
      let removeArray = []
      for (let i = 0; i < 10; i++) {
        removeArray.push(this.$refs['line-move-first-' + (i + 1)][0])
      }
      this.$animejs.remove([this.$refs.polygonDraw, ...removeArray])
    },
    methods: {
      init() {
        // 获取容器宽高
        const w = this.$refs.container.offsetWidth
        const h = this.$refs.container.offsetHeight
        this.height = h + 1
        this.width = w + 1
        //根据宽高设置路径
        this.points =
          '1,1 ' +
          (w - 10) +
          ',1 ' +
          w +
          ',11 ' +
          w +
          ',' +
          (h - 10) +
          ' ' +
          (w - 10) +
          ',' +
          h +
          ' 1 ' +
          h
        this.pointsTop =
          w - 20 + ',1 ' + (w - 10) + ',1 ' + w + ',11 ' + w + ',21 '
        this.pointsBottom =
          w +
          ',' +
          (h - 20) +
          ' ' +
          w +
          ',' +
          (h - 10) +
          ' ' +
          (w - 10) +
          ',' +
          h +
          ' ' +
          (w - 20) +
          ',' +
          h +
          ' '
        // setTimeout(() => {
        //   this.drawLineAn = this.drawLine()
        //   this.lineMove()
        // }, 10)
      },
      //鼠标移入
      drawLineStart() {
        if (this.drawLineAn) {
          this.isMottledShow = false
          if (this.drawDirection == 0) {
            this.drawLineAn.reverse()
            this.drawDirection = 1
          }
          this.drawLineAn.play()
        }
      },
      // 鼠标离开
      drawLineEnd() {
        if (this.drawLineAn) {
          this.isMottledShow = true
          if (this.drawDirection == 1) {
            this.drawLineAn.reverse()
            this.drawDirection = 0
          }

          this.drawLineAn.play()
        }
      },
      //   画线动画
      drawLine() {
        let polygon = this.$refs.polygonDraw
        return this.$animejs({
          targets: polygon,
          strokeDashoffset: [this.$animejs.setDashoffset, 0],
          easing: 'easeInOutSine',
          duration: 500,
          delay: function (el, i) {
            return i * 250
          },
          autoplay: false,
        })
      },
      //   线条移动动画
      lineMove() {
        let path = this.$animejs.path(this.$refs.polygon)
        let tl = this.$animejs.timeline({
          easing: 'linear',
          loop: true,
          duration: 10000,
        })
        for (let i = 0; i < 10; i++) {
          tl.add(
            {
              targets: this.$refs['line-move-first-' + (i + 1)][0],
              translateX: path('x'),
              translateY: path('y'),
            },
            i < 5 ? (10 - i) * 10 : (10 - i) * 10 + 2000
          )
        }
      },
      handleAdd() {
        this.$emit('handleAdd')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .svg-container {
    position: relative;
    width: 100%;
    height: 100%;
    .svg-border,
    .svg-border-top,
    .svg-border-bottom,
    .line-move {
      position: absolute;
      left: 0;
      top: 0;
    }
    .line-move {
      width: 2px;
      height: 2px;
      background-color: #00f6ff;
      top: -1px;
      left: -1px;
      box-shadow: 0 0 3px 3px RGBA(0, 246, 255, 0.1);
    }
    .line-move.green {
      background-color: #00ffac;
      box-shadow: 0 0 3px 3px RGBA(0, 255, 172, 0.1);
    }
    // 杂色边框
    .mottled {
      width: 20px;
      height: 2px;
      position: absolute;
      top: 0;
      left: 3px;
      background-color: rgba(255, 246, 2, 0.3);
      z-index: 3;
      border-radius: 10px;
    }
    .mottled.second {
      width: 15px;
      left: 30px;
      background-color: rgba(2, 255, 163, 0.3);
    }
    .mottled.third {
      width: 15px;
      left: 50px;
      background-color: rgba(255, 255, 255, 0.3);
    }
    .mottled.fourth {
      width: 15px;
      left: 45%;
      background-color: rgba(255, 239, 2, 0.3);
    }
    .mottled.fifth {
      width: 15px;
      left: 55%;
      background-color: rgba(255, 239, 2, 0.3);
    }
    .mottled.sixth {
      width: 15px;
      left: 65%;
      background-color: rgba(255, 239, 2, 0.3);
    }
    // 内容容器
    .svg-content-container {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 9;
      text-align: left;
      padding: 15px;
      display: flex;
      flex-direction: column;
      // 标题
      .svg-title {
        padding: 0 0 0 20px;
        color: white;
        font-size: 16px;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .img_a1 {
          position: absolute;
          left: 5px;
          width: 6px;
          top: 6px;
        }
        .img_a2 {
          position: absolute;
          right: 5px;
          top: 6px;
          cursor: pointer;
        }
      }
      .svg-title-border {
        max-width: 100%;
        overflow: hidden;
        padding-top: 5px;
        img {
          width: 15.625vw;
        }
      }
      // 内容
      .svg-content-center {
        flex-grow: 1;
        padding-top: 10px;
      }
    }
    // 遮罩层
    .mask {
      position: absolute;
      z-index: 999;
      box-sizing: border-box;
      width: 0;
      height: 0;
    }
  }
</style>
